import { FC } from 'react';
import cn from 'classnames';
import ls from 'localstorage-slim';

import { MenuItems } from '../../types/MenuItems';
import { CloseBtn } from '../CloseBtn/CloseBtn';
import { isSixInHash } from '../../helpers/isSixInHash';

import dashboardArrow from '../../assets/images/dashboard/arrow-short.png';
import shopArrow from '../../assets/images/shop/arrow-short.png';
import settingsArrow from '../../assets/images/settings/arrow-short.png';
import marketingArrow from '../../assets/images/marketing/arrow-short.png';
import statisticsArrow from '../../assets/images/statistics/arrow-short.png';
import financeArrow from '../../assets/images/finance/arrow-short.png';

import './SixPageWrapper.scss';

type Props = {
  section: Omit<
    MenuItems,
    MenuItems.LOGIN | MenuItems.LOST | MenuItems.FOOTER | MenuItems.TOGETHER
  >;
  title: string;
  itemsList: { title: string; link: string }[];
};

const arrows: {
  [key: string]: string;
} = {
  dashboard: dashboardArrow,
  shop: shopArrow,
  settings: settingsArrow,
  marketing: marketingArrow,
  statistics: statisticsArrow,
  finance: financeArrow,
};

export const SixPageWrapper: FC<Props> = ({ section, title, itemsList }) => {
  const { hash } = window.location;

  return (
    <section
      className={cn('six-page-wrapper', {
        'six-page-animation--page-open': hash.includes(`${section}`),
        'six-page-animation--page-close': !hash.includes(`${section}`),
        'six-page-wrapper__prev-opened':
          isSixInHash() && `${ls.get('prevSixPage')}`.includes(`${section}`),
      })}
      style={{
        transitionDelay: `${hash !== '#' + section ? '0.69s' : '0s'}`,
      }}
      id={`${section}`}
    >
      <div
        className={cn(`six-page-wrapper__support-bg ${section}-image-bg`, {
          'six-page-animation__bg-open': hash.includes(`${section}`),
          'six-page-animation__bg-close': !isSixInHash(),
        })}
      ></div>
      <div className="six-page-wrapper__container">
        <h2 className={`six-page-wrapper__title ${section}-color`}>
          {window.screen.width > 480 ? title : section}
        </h2>

        <div className="six-page-wrapper__items-container">
          {itemsList.map((item) => (
            <a
              key={item.link}
              href={item.link}
              className={`six-page-wrapper__item`}
            >
              {item.title}
              <div
                style={{
                  opacity: hash === `#${section}` ? '1' : '0',
                }}
                className="six-page-wrapper__btn-arrow-wrapper"
              >
                <img
                  src={arrows[`${section}`]}
                  className="six-page-wrapper__btn-arrow"
                  alt="Arrow"
                />
              </div>
            </a>
          ))}
        </div>

        <CloseBtn
          customClassName={`six-page-wrapper__close-btn ${section}-color`}
        />
      </div>
    </section>
  );
};
